import { FETCH_DASHBOARD_DATA } from "./dashboard-store-constants";

export function fetchDashboard(data) {
  return {
    type: FETCH_DASHBOARD_DATA,
    payload: {
      dashboardData: data
    }
  };
}
